module.exports = __webpack_public_path__ + "img/1573999956.7f56cd6c.jpg";